import ActionTypes from "../enums/ActionTypes"

export function fetchUserRights() {
  return {
    type: ActionTypes.USER_RIGHTS_REQUEST,
  }
}
